import { render } from "./GameStandings.vue?vue&type=template&id=6ba17b6c&scoped=true"
import script from "./GameStandings.vue?vue&type=script&scoped=true&lang=js"
export * from "./GameStandings.vue?vue&type=script&scoped=true&lang=js"

import "./GameStandings.vue?vue&type=style&index=0&id=6ba17b6c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jgurl\\KontraWebsite\\KontraSports\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba17b6c"]])

export default __exports__